var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_2131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.88293 0 0.5 5.38293 0.5 12C0.5 18.6171 5.88293 24 12.5 24C19.1171 24 24.5 18.6171 24.5 12C24.5 5.38293 19.1171 0 12.5 0Z",
    fill: "#0E60B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7499 12.9999H13.4999V17.2499C13.4999 17.802 13.052 18.2499 12.4999 18.2499C11.9479 18.2499 11.5 17.802 11.5 17.2499V12.9999H7.24994C6.69788 12.9999 6.25 12.552 6.25 11.9999C6.25 11.4479 6.69788 11 7.24994 11H11.5V6.74994C11.5 6.19788 11.9479 5.75 12.4999 5.75C13.052 5.75 13.4999 6.19788 13.4999 6.74994V11H17.7499C18.302 11 18.7499 11.4479 18.7499 11.9999C18.7499 12.552 18.302 12.9999 17.7499 12.9999Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_2131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.4128dfef41a84ad7671c06d6200f84a7.svg";
export { ForwardRef as ReactComponent };